var app = angular.module('leonardo');

var PortfolioListFilter = function () {
  return function (account) {
    if (!account || account.length === 0) {
      return;
    }
    if (account.is_owner) {
      return 'All portfolios';
    }
    if (!account.portfolios || account.portfolios.length === 0) {
      return '-';
    }
    if (account.portfolios && account.portfolios.length > 3) {
      return account.portfolios.length + ' portfolios';
    }
    var names = [];
    angular.forEach(account.portfolios, function(item) {
      names.push(item.name);
    });
    names.sort();
    return names.join(', ');
  };
};

app.filter('portfolioList', [PortfolioListFilter]);
